import {
  TransportBoxDto,
  CatalogItemDto,
} from "../../../api/generated/api-client";
import { LastAddedItem } from "../../../api/hooks/useLastAddedItem";
import { LastManufacturedEntry } from "../../../api/hooks/useLastManufacturedItems";
import { ManufacturedProductInventoryItem } from "../../../api/hooks/useManufacturedProductInventory";

export interface TransportBoxDetailProps {
  boxId: number | null;
  isOpen: boolean;
  onClose: () => void;
}

export interface ApiClientWithInternals {
  baseUrl: string;
  http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
}

export interface TransportBoxInfoProps {
  transportBox: TransportBoxDto;
  descriptionInput: string;
  handleDescriptionChange: (value: string) => void;
  isDescriptionChanged: boolean;
  isFormEditable: (fieldType: "items" | "notes" | "boxNumber") => boolean;
  formatDate: (dateString: string | Date | undefined) => string;
  handleSaveNote: () => void;
}

export interface AddManufacturedItemInput {
  item: ManufacturedProductInventoryItem;
  amount: number;
  allowNegativeStock?: boolean;
}

export interface TransportBoxItemsProps {
  transportBox: TransportBoxDto;
  isFormEditable: (fieldType: "items" | "notes" | "boxNumber") => boolean;
  formatDate: (dateString: string | Date | undefined) => string;
  handleRemoveItem: (itemId: number, amount?: number) => void;
  quantityInput: string;
  setQuantityInput: (value: string) => void;
  selectedProduct: CatalogItemDto | null;
  setSelectedProduct: (product: CatalogItemDto | null) => void;
  handleAddItem: () => void;
  handleAddManufacturedItem: (input: AddManufacturedItemInput) => Promise<void>;
  // Quick add last item functionality
  lastAddedItem: LastAddedItem | null;
  handleQuickAdd: () => void;
  // Repeat last box (manufactured)
  lastManufacturedItems: LastManufacturedEntry[];
}

export interface TransportBoxHistoryProps {
  transportBox: TransportBoxDto;
  formatDate: (dateString: string | Date | undefined) => string;
}

export interface TransportBoxActionsProps {
  transportBox: TransportBoxDto;
  changeStateMutation: any;
  handleStateChange: (newStateString: string) => void;
}

export interface TransportBoxModalsProps {
  transportBox: TransportBoxDto;
  isAddItemModalOpen: boolean;
  setIsAddItemModalOpen: (value: boolean) => void;
  isLocationSelectionModalOpen: boolean;
  setIsLocationSelectionModalOpen: (value: boolean) => void;
  handleAddItemSuccess: () => void;
  handleLocationSelectionSuccess: () => void;
}

export interface TransportBoxStateBadgeProps {
  state: string;
  size?: "sm" | "md" | "lg";
}

// State labels mapping - using enum keys
export const stateLabels: Record<string, string> = {
  New: "Nový",
  Opened: "Otevřený",
  InTransit: "V přepravě",
  Received: "Přijatý",
  Stocked: "Naskladněný",
  Reserve: "V rezervě",
  Quarantine: "V karanténě",
  Closed: "Uzavřený",
  Error: "Chyba",
};

export const stateColors: Record<string, string> = {
  New: "bg-gray-100 text-gray-800 dark:bg-graphite-surface-2 dark:text-graphite-muted",
  Opened: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300",
  InTransit: "bg-yellow-100 text-yellow-800 dark:bg-amber-900/30 dark:text-amber-300",
  Received: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300",
  Stocked: "bg-green-100 text-green-800 dark:bg-emerald-900/30 dark:text-emerald-300",
  Reserve: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300",
  Quarantine: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300",
  Closed: "bg-gray-100 text-gray-800 dark:bg-graphite-surface-2 dark:text-graphite-muted",
  Error: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
};
